import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {Container, Col, Row} from 'reactstrap';
import lodash from 'lodash';
import {isMobile} from 'react-device-detect';
import './style.scss';
import HeadLineComponent from '../HeadLineComponent';
import PaymentBoxComponent from './PaymentBoxComponent';
import AllCustomersComponent from './AllCustomersComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PaymentsErrorPage from './PaymentsErrorPage';
import PopUp from '../../../Shared/Popup/PopUp';
import images from '../images/images';
import checkIcon from '../images/check.svg';
import {getReportParams, report} from '../../../../middleware/report';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {
  gaReportShownPage,
  gaReportOnButtonClick,
  gaReportOnClickForwardWithUpdatePrivate,
  gaShowNumOfMethods,
  gaShowNumOfOrgNoPayment,
  gaNumOfOrgSelected,
  gaShowNumOfMethodsPrivate,
  gaClickCheckBoxForSelectingPrivate,
} from './../gaReports';
import {dwhEnterUpdatePayment, dwhSelectPaymentMethod} from './../dwhReports';

const SelectCustomersComponent = ({props, setSelectedCustomers, backToLobby}) => {
  if (props.data.currentStep !== 3) {
    return null;
  }
  let customersPaymentDataArray = [...props.data.selectedForUpdate?.customersPaymentData];
  const customersPaymentData = !props.data.isBusinessBlock
    ? customersPaymentDataArray.sort(paymentMethodTypeSorter)
    : props.data.selectedForUpdate?.customersPaymentData;
  const businessBtnTxt = 'חזרה לאזור העסקי';
  const privateBtnTxt = ' לאזור האישי';
  const privateBtnTxtFail = 'סיום';
  const btnTxt = !props.data.isBusinessBlock ? (customersPaymentData.length <= 0 ? privateBtnTxtFail : privateBtnTxt) : businessBtnTxt;

  const [activePaymentMethod, setActivePaymentMethod] = useState(null);
  const [activeMethodNumber, setActiveMethodNumber] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [hiddenNumber, setHiddenNumber] = useState(null);
  const [animateOut, setAnimateOut] = useState(false);
  const [onlyOnePaymentMethod, setOnlyOnePaymentMethod] = useState(null);
  const [privateChecked, setPrivateChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [selectedAccountsData, setSelectedAccountsData] = useState({});
  const [pageTitle, setPageTitle] = useState('אמצעי התשלום שלך');
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [showSelectionError, setShowSelectionError] = useState(false);
  const [isAccountSelectionPhase, setIsAccountSelectionPhase] = useState(false);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState([]);
  const [expandedCards, setExpandedCards] = useState({});

  const onlyPSIDAccounts = !props.data.isBusinessBlock && props.data.onlyPSIDAccounts;

  // Check if any payment method is BANK and user is not business to determine if popup should show
  const hasBankPaymentMethod = customersPaymentData?.some((paymentData) => paymentData.paymentMethodType === 'BANK');
  const shouldShowPopup = hasBankPaymentMethod && !props.data.isBusinessBlock;

  const isButtonDisabled = () => {
    const hasOldSelection = customersPaymentData.some((data) => data.customersList.some((customer) => customer.checked === true));

    const hasNewSelection = Object.values(selectedAccountsData).some((accounts) => Array.isArray(accounts) && accounts.length > 0);

    const shouldDisable = !hasOldSelection && !hasNewSelection;

    return shouldDisable;
  };

  let disabledBtn = isButtonDisabled();

  function paymentMethodTypeSorter(a, b) {
    return (b.paymentMethodType === 'UNKNOW') - (a.paymentMethodType === 'UNKNOW');
  }

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects() && !props.data.isBusinessBlock && customersPaymentData?.length == 1 && !props.data.isPrivateDefaultAreSelected) {
      savePrivateDefaultCustomers();
    }
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (!props.data.isBusinessBlock) {
      if (runSideEffects()) {
        dwhEnterUpdatePayment(false);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    setSelectedAccountsData({});
    setPageTitle('אמצעי התשלום שלך');

    // Show popup only if there's a BANK payment method and user is not business
    setShowPopup(shouldShowPopup);

    if (!activeMethodNumber) {
      if (props.data.isBusinessBlock) {
        gaReportShownPage('all_payment_methods');
        gaShowNumOfMethods(customersPaymentData.length);

        let numOfNoPaymentMethod = 0;
        customersPaymentData.forEach((item) => {
          if (item.paymentMethodType === 'DIFFERENT') {
            numOfNoPaymentMethod = item.customersList.length;
          }
        });
        gaShowNumOfOrgNoPayment(`${numOfNoPaymentMethod}_חשבונות_ללא_אמצעי_תשלום`);
      } else {
        gaShowNumOfMethodsPrivate(customersPaymentData.length);
      }
    }
    setTimeout(() => {
      props.setProgressBarPercent(40);
    }, props.data.animationTimeOut);
  }, [shouldShowPopup]);

  // Add/remove body class for mobile account selection
  useEffect(() => {
    if (isAccountSelectionPhase && isMobile) {
      document.body.classList.add('mobile-account-selection-active');
    } else {
      document.body.classList.remove('mobile-account-selection-active');
    }

    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove('mobile-account-selection-active');
    };
  }, [isAccountSelectionPhase, isMobile]);

  const handleAccountSelectionChange = (selectedAccounts, paymentType) => {
    setSelectedAccountsData((prev) => ({
      ...prev,
      [paymentType]: selectedAccounts,
    }));

    // Clear error message when a selection is made
    if (selectedAccounts.length > 0) {
      setShowSelectionError(false);
    }

    const updatedCustomerData = customersPaymentData.map((paymentMethod) => {
      if (paymentMethod.paymentMethodType === paymentType) {
        return {
          ...paymentMethod,
          customersList: paymentMethod.customersList.map((customer) => ({
            ...customer,
            checked: false,
          })),
        };
      }
      return paymentMethod;
    });

    setSelectedCustomers(updatedCustomerData);

    setUpdateTrigger((prev) => prev + 1);
  };

  const handleTitleChange = (newTitle) => {
    setPageTitle(newTitle);
  };

  const openForSelecting = (hiddenNumber, method, data) => {
    // Clear error message when any payment method is selected
    setShowSelectionError(false);

    if (!props.data.isBusinessBlock) {
      gaClickCheckBoxForSelectingPrivate(props.data.paymentMethods[method]);

      let onlyOneCustomer =
        customersPaymentData.find((pd) => pd.paymentMethodType == method && pd.paymentMethodNumber?.trim() == data?.trim())?.customersList
          ?.length == 1;

      if (onlyOnePaymentMethod || onlyOneCustomer) {
        savePrivateDefaultCustomers(method, data);
        setPrivateChecked(!privateChecked);
        return;
      }

      // For multiple payment methods, don't open AllCustomersComponent - just toggle the payment method selection
      if (customersPaymentData.length > 1) {
        // Check if this payment method is currently selected
        const currentPaymentMethod = customersPaymentData.find(
          (paymentMethod) =>
            paymentMethod.paymentMethodType == method &&
            paymentMethod.paymentMethodNumber?.trim() == data?.trim()
        );

        const isCurrentlySelected = currentPaymentMethod?.customersList.some(customer => customer.checked);

        // Toggle the selection - if currently selected, deselect all; if not selected, select all
        const newData = customersPaymentData.map((paymentMethod) => {
          if (
            paymentMethod.paymentMethodType == method &&
            paymentMethod.paymentMethodNumber?.trim() == data?.trim()
          ) {
            return {
              ...paymentMethod,
              customersList: paymentMethod.customersList.map((customer) => ({
                ...customer,
                checked: !isCurrentlySelected, // Toggle based on current state
              })),
            };
          }
          return paymentMethod;
        });
        setSelectedCustomers(newData);
        return;
      }
    }

    // For business users with multiple payment methods, just toggle payment method selection (like private users)
    if (props.data.isBusinessBlock && customersPaymentData.length > 1) {
      // Check if this payment method is currently selected
      const currentPaymentMethod = customersPaymentData.find(
        (paymentMethod) =>
          paymentMethod.paymentMethodType == method &&
          paymentMethod.paymentMethodNumber?.trim() == data?.trim()
      );

      const isCurrentlySelected = currentPaymentMethod?.customersList.some(customer => customer.checked);

      // Toggle the selection - if currently selected, deselect all; if not selected, select all
      const newData = customersPaymentData.map((paymentMethod) => {
        if (
          paymentMethod.paymentMethodType == method &&
          paymentMethod.paymentMethodNumber?.trim() == data?.trim()
        ) {
          return {
            ...paymentMethod,
            customersList: paymentMethod.customersList.map((customer) => ({
              ...customer,
              checked: !isCurrentlySelected, // Toggle based on current state
            })),
          };
        }
        return paymentMethod;
      });
      setSelectedCustomers(newData);
      return;
    }

    // Update title for account selection (only for single payment method)
    setPageTitle('החשבונות שיעודכנו');
    setActivePaymentMethod(props.data.paymentMethods[method]);
    setActiveMethodNumber(data);
    setHiddenNumber(hiddenNumber);
  };

  const getPaymentBoxData = (data) => {
    const starsCount = props.data.paymentMethods[data.paymentMethodType] == props.data.paymentMethods.CREDIT_CARD ? 12 : 4;

    const object = {
      id: data.id,
      type: data.paymentMethodType,
      image: null,
      title: null,
      checked: false,
      number: '',
      hiddenNumber: '',
      paymentMethodDescription: props.data.paymentMethods[data.paymentMethodType],
    };

    let selected = data.customersList.some((customer) => customer.checked == true);

    let string = getButtonString(props.data.paymentMethods[data.paymentMethodType], selected, data.customersList);
    let src = getImage(props.data.paymentMethods[data.paymentMethodType]);
    let paymentNumberStr =
      props.data.paymentMethods[data.paymentMethodType] == props.data.paymentMethods.DIFFERENT
        ? ''
        : getPaymentNumberString(starsCount, data?.paymentMethodNumber?.trim());
    return {
      ...object,
      title: string,
      image: src,
      number: data?.paymentMethodNumber?.trim(),
      hiddenNumber: paymentNumberStr,
      checked: selected,
    };
  };

  const getPaymentNumberString = (count, number) => {
    let str = '';
    let visibleStr = number?.substring(number.length - 4);

    for (let i = 1; i <= count; i++) {
      str += i == 4 || i == 8 || i == 12 ? '* ' : '*';
    }
    str = visibleStr != undefined ? visibleStr + ' ' + str : '****' + ' ' + str;
    return str;
  };

  const getButtonString = (paymentMethodDescription, selected, customersList) => {
    let string;
    if (!selected) {
      if (paymentMethodDescription == props.data.paymentMethods.CREDIT_CARD || paymentMethodDescription == props.data.paymentMethods.BANK) {
        string = customersList.length == 1 ? 'מוגדר בחשבון אחד' : `מוגדר ב-${customersList.length} חשבונות`;
      } else {
        string = customersList.length > 1 ? `${customersList.length} חשבונות ללא אמצעי תשלום ` : 'חשבון אחד ללא אמצעי תשלום';
      }
    } else {
      var results = lodash.filter(customersList, function (customer) {
        return customer.checked == true;
      });
      string = `בחרתם לעדכן ${results.length} מתוך ${customersList.length} חשבונות`;
    }
    return string;
  };

  const getImage = (type) => {
    let src;
    switch (type) {
      case props.data.paymentMethods.BANK:
        src = images.bank;
        break;
      case props.data.paymentMethods.CREDIT_CARD:
        src = images.creditcard;
        break;
      case props.data.paymentMethods.DIFFERENT:
        src = images.differentpayment;
        break;
      case props.data.paymentMethods.PAYPAL:
        src = images.paypal;
        break;
      default:
        src = images.differentpayment;
    }
    return src;
  };

  const savePrivateDefaultCustomers = (paymentMethod, paymentNumberData) => {
    let defaultSelection = paymentMethod ? false : true;

    const newPrivateData = customersPaymentData.map((method) => {
      if (
        method.customersList.length == 1 &&
        (defaultSelection ||
          (!defaultSelection &&
            method.paymentMethodType == paymentMethod &&
            method.paymentMethodNumber?.trim() == paymentNumberData?.trim()))
      ) {
        return {
          ...method,
          customersList: method.customersList.map((customer) => {
            return {
              ...customer,
              checked: !customer.checked,
            };
          }),
        };
      }
      return method;
    });
    setSelectedCustomers(newPrivateData);
    props.setIsPrivateDefaultAreSelected(true);
  };

  const saveSelectedCustomers = (data, toggleAll = false) => {
    // Clear error message when customers are selected
    setShowSelectionError(false);

    if (props.data.isBusinessBlock) {
      gaReportOnButtonClick('select_customers_page_finish_selecting');
      gaNumOfOrgSelected(data.count);
    }

    setLastUpdated({method: activePaymentMethod, number: activeMethodNumber});

    let list = data.items ? data.items : data;

    if (toggleAll) {
      list = list.map((customer) => {
        return {
          ...customer,
          checked: true,
        };
      });
    }

    const currentActivePaymentMethod = activePaymentMethod;
    const currentActiveMethodNumber = activeMethodNumber;
    const newData = customersPaymentData.map((method) => {
      if (
        currentActivePaymentMethod == props.data.paymentMethods[method.paymentMethodType] &&
        currentActiveMethodNumber == method?.paymentMethodNumber?.trim()
      ) {
        return {
          ...method,
          customersList: list,
        };
      }
      return method;
    });

    setSelectedCustomers(newData);
    setActivePaymentMethod(null);
    setActiveMethodNumber(null);
    props.saveToHistory();
  };

  const gaAndBackToBusinessLobby = () => {
    gaReportOnButtonClick('all_payment_methods_back_to_business_lobby');
    backToLobby();
  };

  const continueToUpdate = () => {
    // For multiple payment methods OR single payment method in selection mode, check if any selection is made
    if (customersPaymentData.length > 1 || (customersPaymentData.length === 1 && isSelectionMode)) {
      const hasOldSelection = customersPaymentData.some((data) => data.customersList.some((customer) => customer.checked === true));

      const hasNewSelection = Object.values(selectedAccountsData).some((accounts) => Array.isArray(accounts) && accounts.length > 0);

      if (!hasOldSelection && !hasNewSelection) {
        setShowSelectionError(true);
        return;
      }
    }

    setShowSelectionError(false);

    // NEW LOGIC: For private users with multiple payment methods, go to account selection phase first
    if (!props.data.isBusinessBlock && customersPaymentData.length > 1 && !isAccountSelectionPhase) {
      // Store selected payment methods and move to account selection phase
      const selectedMethods = customersPaymentData.filter((data) => data.customersList.some((customer) => customer.checked === true));

      setSelectedPaymentMethods(selectedMethods);
      setIsAccountSelectionPhase(true);
      setPageTitle('החשבונות שיעודכנו');

      // Initialize all accounts as selected by default
      const defaultAccountSelection = {};
      const defaultExpandedState = {};
      selectedMethods.forEach((method) => {
        defaultAccountSelection[method.paymentMethodType] = method.customersList.map((customer) => customer.id);
        defaultExpandedState[method.paymentMethodType] = true; // Start expanded
      });
      setSelectedAccountsData(defaultAccountSelection);
      setExpandedCards(defaultExpandedState);

      return; // Don't proceed to next step yet
    }

    // NEW LOGIC: For business users with multiple payment methods, go to account selection phase first
    if (props.data.isBusinessBlock && customersPaymentData.length > 1 && !isAccountSelectionPhase) {
      // Store selected payment methods and move to account selection phase
      const selectedMethods = customersPaymentData.filter((data) => data.customersList.some((customer) => customer.checked === true));

      setSelectedPaymentMethods(selectedMethods);
      setIsAccountSelectionPhase(true);
      setPageTitle('החשבונות שיעודכנו');

      // Initialize all accounts as selected by default
      const defaultAccountSelection = {};
      const defaultExpandedState = {};
      selectedMethods.forEach((method) => {
        defaultAccountSelection[method.paymentMethodType] = method.customersList.map((customer) => customer.id);
        defaultExpandedState[method.paymentMethodType] = true; // Start expanded
      });
      setSelectedAccountsData(defaultAccountSelection);
      setExpandedCards(defaultExpandedState);

      return; // Don't proceed to next step yet
    }

    // Original logic for business users, single payment, or final step for private multiple payments
    dwhSelectPaymentMethod(props.data.isBusinessBlock);
    let nextStep = 4;
    if (!props.data.isBusinessBlock) {
      gaReportOnClickForwardWithUpdatePrivate();
      props.saveNewSelectedPaymentMethod('CC');
      nextStep = 5;
    }

    if (Object.keys(selectedAccountsData).length > 0) {
      const updatedCustomerData = customersPaymentData.map((paymentMethod) => {
        const selectedAccounts = selectedAccountsData[paymentMethod.paymentMethodType];
        if (selectedAccounts && selectedAccounts.length > 0) {
          return {
            ...paymentMethod,
            customersList: paymentMethod.customersList.map((customer) => ({
              ...customer,
              checked: selectedAccounts.includes(customer.id),
            })),
          };
        }
        return paymentMethod;
      });

      setSelectedCustomers(updatedCustomerData);
    }

    setAnimateOut(true);
    setTimeout(() => {
      props.handleCurrentStep(nextStep);
    }, props.data.animationTimeOut);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  const enterSelectionMode = () => {
    setIsSelectionMode(true);
  };

  const exitSelectionMode = () => {
    setIsSelectionMode(false);
    setSelectedAccountsData({});
    setPageTitle('אמצעי התשלום שלך');
  };

  const exitAccountSelectionPhase = () => {
    setIsAccountSelectionPhase(false);
    setSelectedPaymentMethods([]);
    setSelectedAccountsData({});
    setExpandedCards({});
    setPageTitle('אמצעי התשלום שלך');
  };

  const handleAccountSelectionInPhase = (accountId, paymentMethodType, isSelected) => {
    setSelectedAccountsData((prev) => {
      const currentSelections = prev[paymentMethodType] || [];
      if (isSelected) {
        return {
          ...prev,
          [paymentMethodType]: [...currentSelections, accountId],
        };
      } else {
        return {
          ...prev,
          [paymentMethodType]: currentSelections.filter((id) => id !== accountId),
        };
      }
    });
  };

  const toggleCardExpanded = (paymentMethodType) => {
    setExpandedCards((prev) => ({
      ...prev,
      [paymentMethodType]: !prev[paymentMethodType],
    }));
  };

  return (
    <div className={`${animateOut ? 'animateOut' : 'animateIn'}`} style={{position: 'relative'}}>
      <HeadLineComponent text={pageTitle} />
      {!isAccountSelectionPhase && customersPaymentData.length > 1 && (
        <div className='payment-method-selection-description'>בחרו אמצעי תשלום שתרצו לעדכן</div>
      )}
      <div className={`${isAccountSelectionPhase && isMobile ? 'mobile-account-selection-container' : ''} payment-box-cards-wrapper`}>
        {isAccountSelectionPhase ? (
          // Account Selection Phase for Multiple Payment Methods
          <div style={{display:'flex',width:'100%',flexDirection:'column',alignItems:'center'}}>
            <p className='headline-text-description'>בחרו את החשבונות שתרצו לעדכן עבור כל אמצעי תשלום</p>

            <div className='background-container'>
              {selectedPaymentMethods.map((paymentMethod, index) => {
                const paymentMethodDescription = props.data.paymentMethods[paymentMethod.paymentMethodType];
                const selectedAccounts = selectedAccountsData[paymentMethod.paymentMethodType] || [];

                return (
                  <div key={index} className='payment-box-card'>
                    <div className='payment-box-card__content'>
                      <div className='payment-box-card__header'>
                        <div className='payment-box-card__main-info account-selection-horizontal'>
                          <div className='payment-box-card__icon'>
                            <Image src={getImage(paymentMethod.paymentMethodType)} alt={paymentMethodDescription} />
                          </div>
                          <div className='payment-box-card__payment-details'>
                            <div className='payment-box-card__description'>
                              {(() => {
                                // Format display based on payment method type
                                if (paymentMethod.paymentMethodType === 'DIFFERENT' || paymentMethod.paymentMethodType === 'UNKNOW') {
                                  return paymentMethodDescription;
                                } else {
                                  // For all payment methods with numbers, show last 4 digits + **** if available, otherwise just ****
                                  if (paymentMethod.paymentMethodNumber) {
                                    // Extract only digits from the payment method number
                                    const digits = paymentMethod.paymentMethodNumber.replace(/\D/g, '');
                                    const lastFour = digits.length >= 4 ? digits.slice(-4) : null;
                                    return lastFour ? `${paymentMethodDescription} | ${lastFour} ****` : `${paymentMethodDescription} | ****`;
                                  } else {
                                    return `${paymentMethodDescription} | ****`;
                                  }
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='payment-box-card__footer'>
                        <div
                          className='payment-box-card__expandable-trigger disabled'
                          onClick={null}>
                          <span className='payment-box-card__expand-text'>{`מוגדר ב-${paymentMethod.customersList.length} חשבונות`}</span>
                          <span className={`payment-box-card__chevron expanded`}>
                            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
                              <path
                                d='M12.456 11.2399C12.8332 11.6114 13.417 11.5813 13.7599 11.1727C14.0765 10.7954 14.0772 10.2275 13.7787 9.8502L13.6978 9.76005L8.62093 4.76006C8.29819 4.44221 7.81948 4.41572 7.47074 4.6806L7.37907 4.76006L2.30215 9.76005C1.92493 10.1316 1.89713 10.764 2.24006 11.1727C2.55661 11.5499 3.0784 11.6046 3.4535 11.3185L3.54401 11.2399L7.99908 6.851L12.456 11.2399Z'
                                fill='black'
                              />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div className='payment-box-card__expanded-content'>
                          <div className='payment-box-card__account-selection'>
                            <div className='selectable-accounts-list'>
                              {paymentMethod.customersList.map((account, accountIndex) => (
                                <div key={accountIndex} className='selectable-account-item'>
                                  <div className='account-checkbox'>
                                    <input
                                      type='checkbox'
                                      id={`account-${paymentMethod.paymentMethodType}-${account.id}`}
                                      checked={selectedAccounts.includes(account.id)}
                                      onChange={(e) =>
                                        handleAccountSelectionInPhase(account.id, paymentMethod.paymentMethodType, e.target.checked)
                                      }
                                    />
                                    {selectedAccounts.includes(account.id) && (
                                      <Image src={checkIcon} alt='check' className='account-checkbox__check' />
                                    )}
                                  </div>
                                  <div className='account-details'>
                                    <div className='account-number'>חשבון {account.id}</div>
                                    <div className='account-name'>{account.name}</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : activePaymentMethod === null ? (
          <div className='payment-box-cards-container'>
            {customersPaymentData.length > 0 ? (
              <>
                {customersPaymentData.map((data, index) => {
                  const dataForComponent = getPaymentBoxData(data);
                  const isSinglePayment = props.data.selectedForUpdate.customersPaymentData.length === 1;
                  const useFlexLayout = !isSinglePayment || isSelectionMode;

                  return (
                    <>
                      <PaymentBoxComponent
                        updateSliceProps={props}
                        type={dataForComponent.type}
                        description={dataForComponent.paymentMethodDescription}
                        title={dataForComponent.title}
                        image={dataForComponent.image}
                        key={index}
                        checked={dataForComponent.checked}
                        number={dataForComponent.hiddenNumber}
                        customersPaymentList={customersPaymentData[index]?.customersList}
                        isLastUpdated={
                          data.paymentMethodNumber == lastUpdated?.number &&
                          props.data.paymentMethods[data.paymentMethodType] == lastUpdated?.method
                            ? true
                            : false
                        }
                        toggleComponent={() =>
                          openForSelecting(dataForComponent.hiddenNumber, dataForComponent.type, dataForComponent.number)
                        }
                        onlyOnePaymentMethod={onlyOnePaymentMethod}
                        paymentMethods={props.data.paymentMethods}
                        onAccountSelectionChange={handleAccountSelectionChange}
                        onTitleChange={handleTitleChange}
                        isSinglePayment={isSinglePayment}
                        isSelectionMode={isSelectionMode}
                        onEnterSelectionMode={enterSelectionMode}
                        useFlexLayout={useFlexLayout}
                      />

                    </>
                  );
                })}
              </>
            ) : (
              <PaymentsErrorPage isBusinessBlock={props.data.isBusinessBlock} onlyPSIDAccounts={onlyPSIDAccounts} />
            )}
          </div>
        ) : (
          <AllCustomersComponent
            data={customersPaymentData.filter((obj) => {
              return (
                props.data.paymentMethods[obj.paymentMethodType] === activePaymentMethod &&
                obj?.paymentMethodNumber?.trim() == activeMethodNumber
              );
            })}
            paymentMethod={activePaymentMethod}
            hiddenNumber={hiddenNumber}
            saveSelectedCustomers={(data, toggleAll) => saveSelectedCustomers(data, toggleAll)}
            props={props}
          />
        )}

        {(activePaymentMethod === null || isAccountSelectionPhase) && (
          <div className='mobile-bottom-buttons-wrapper'>
            <div className={`${isMobile ? 'mobile-bottom-buttons' : 'mobile-bottom-buttons-wrapper'}`} >
              {isAccountSelectionPhase ? (
                <div className={`${isMobile ? 'mobile-account-selection-button' : 'phase-2-button-continue'}`}>
                  {props.data.isBusinessBlock && (
                    <button
                      className='white-lobby-button'
                      onClick={exitAccountSelectionPhase}
                      style={{marginBottom: '10px'}}
                    >
                      חזרה לבחירת אמצעי תשלום
                    </button>
                  )}
                  <BtnSubmit
                    className='phase-2-button'
                    isBusiness={props.data.isBusinessBlock}
                    text='המשך'
                    onclick={() => {
                      continueToUpdate();
                    }}
                  />
                </div>
              ) : customersPaymentData.length > 0 ? (
                customersPaymentData.length > 1 ? (
                  // Multiple payment methods - show only המשך button
                  <div className='multiple-payment-buttons'>
                    {showSelectionError && <div className='selection-error-text'>יש לבחור לפחות אמצעי תשלום אחד</div>}
                    <BtnSubmit
                      isBusiness={props.data.isBusinessBlock}
                      text='המשך'
                      onclick={() => {
                        continueToUpdate();
                      }}
                    />
                  </div>
                ) : // Single payment method - use two-mode system
                isSelectionMode ? (
                  <div className='btn-submit-container'>
                    {showSelectionError && <div className='selection-error-text'>יש לבחור לפחות אמצעי תשלום אחד</div>}
                    <BtnSubmit
                      isBusiness={props.data.isBusinessBlock}
                      text='המשך'
                      onclick={() => {
                        continueToUpdate();
                      }}
                    />
                  </div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    {isMobile && (
                      <button className='white-lobby-button' onClick={() => gaAndBackToBusinessLobby()}>
                        {btnTxt}
                      </button>
                    )}
                  </div>
                )
              ) : (
                <Col xs={12} className={`${props.data.isBusinessBlock ? 'btn-337' : ''}  btn-row pr-0 pl-0 text-center`}>
                  <BtnSubmit isBusiness={props.data.isBusinessBlock} text={btnTxt} onclick={() => gaAndBackToBusinessLobby()} />
                </Col>
              )}
            </div>
          </div>
        )}
      </div>

      <PopUp
        showPopUp={showPopup}
        onClose={handlePopupClose}
        className='select-customers-popup-credit-card-only'
        footerBtn={{
          text: 'הבנתי, תודה',
          onBtnClick: handlePopupClose,
        }}>
        <div className='popup-content'>
          <Image src={images.bigInsight} className='big-insight' />
          <div className='h2-title'>
            בתהליך זה אפשר לעדכן <br /> לאשראי בלבד
          </div>
          <div className='description'>
            אם ברצונכם לעדכן את אמצעי התשלום <br /> להוראת קבע, פנו ל - {window.Config.financeCallNumber1}
          </div>
        </div>
      </PopUp>
    </div>
  );
};

export default SelectCustomersComponent;
